interface HTMLElementEvent<T extends HTMLElement> extends Event {
  target: T
}

class AppModal {
  constructor(
    public closetarget: string,
    public opentarget: string,
    public $: any
  ) {
    this.closetarget = closetarget
    this.opentarget = opentarget
    this.$ = $
  }

  Main() {
    const _that = this.$

    const closebtn = _that(this.closetarget)
    const openbtn = _that(this.opentarget)
    const docu = _that(document)
    const modal = _that('.modal')
    const modalbox = _that('.modalbox')
    const mainElements: any = document.getElementById('mainElements')

    openbtn.click(function(event: HTMLElementEvent<HTMLInputElement>): void {
      event.preventDefault()
      AppModal.openplay(modal, modalbox)
      const _ = _that(event.target)
      const bool_set_data = event.target.classList
      const set_url = _.attr('data-set')
      let concat_elements
      if (bool_set_data.contains('youtube_img')) {
        concat_elements = `<iframe class="iframesp" src="${set_url}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen playsinline></iframe>`
      } else if (bool_set_data.contains('zoom_img')) {
        const slice_url = set_url.split('/')
        const replace_url = slice_url[slice_url.length - 1].replace('.jpg', '')
        concat_elements = `<img class="${replace_url}" src=${set_url}>`
      }
      mainElements.innerHTML = concat_elements
    })

    closebtn.click(function(event: HTMLElementEvent<HTMLInputElement>): void {
      event.preventDefault()
      AppModal.closeplay(modal, modalbox)
    })

    docu.on('click touchstart', function(
      event: HTMLElementEvent<HTMLInputElement>
    ): void {
      if (event.target.classList.contains('modal')) {
        event.preventDefault()
        AppModal.closeplay(modal, modalbox)
      } else {
        return
      }
    })
  }

  static closeplay(modal: any, modalbox: any) {
    modal.removeClass('open')
    modalbox.removeClass('open')
  }
  static openplay(modal: any, modalbox: any) {
    modal.addClass('open')
    modalbox.addClass('open')
  }
}

export default AppModal
